<!--
 * @Description: 常规工作 班主任代选
 * @Author: PF
 * @Date: 2023-06-13 09:48:15
 * @LastEditors: PF
 * @LastEditTime: 2025-12-02 10:43:04
-->
<template>
  <div>
    <el-dialog class="wp80 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">班主任代选</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header>
          <el-select v-model="dataGrid.parms.xqid" placeholder="学期" @change='initBanJi()' class="w200 mb10" filterable>
            <el-option v-for="(item, index) in xqData" :key="index" :label="item.xqmc" :value="item.id" />
          </el-select>
          <el-tabs v-model="dataGrid.parms.bjid" @tab-change="bindTable()">
            <el-tab-pane v-for="(item, index) in bjData" :key="index" :label="item.xzbmc" :name="item.id"></el-tab-pane>
          </el-tabs>
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <!-- 搜索区域 BEGIN -->
            <el-form-item>
              <el-select v-model="dataGrid.parms.xkfs" placeholder="选课方式" @change='bindTable()' clearable filterable>
                <el-option v-for="(item, index) in xkfsData.list" :key="index" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="学生姓名" v-model="dataGrid.parms.xsxm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button type="primary" @click="openPiLiangSheZhi=true;row=dataGrid.parms"><span class="iconfont icon-piliang"></span>批量设置</el-button>
            <!-- <el-button type="primary" @click="tiJiaoClick"><span class="iconfont icon-chuangjian"></span>提交</el-button> -->
          </div>
          <!-- 按钮区域 END -->
        </el-header>
        <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="学生姓名" prop="xm" min-width="110" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="限定选修课程" prop="xbmc" min-width="150" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-for="(item, index) in scope.row.xdxxks" :key="index">
                  <span v-if="index>0">、</span>
                  {{ item.kcmc }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="任意选修课程" prop="zymc" min-width="150" align="center" show-overflow-tooltip >
              <template #default="scope">
                <span v-for="(item, index) in scope.row.ryxxks" :key="index">
                  <span v-if="index>0">、</span>
                  {{ item.kcmc }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="合计学分" prop="hjxf" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="选课方式" prop="xkfs" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
              <template #default="scope">
                <span v-for="(item, index) in xkfsData.list" :key="index">
                  <span v-if="item.value === scope.row.xkfs">{{ item.name }}</span>
                </span>
              </template>
              </el-table-column>
            <el-table-column label="报名时间" prop="bmsj" min-width="150" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="180" fixed="right" align="center">
              <template #default="scope">
                <div v-if="scope.row.id">
                  <el-button link type="success" @click="openDetail=true; row={id:scope.row.id,xsid:scope.row.xsid,xqid:dataGrid.parms.xqid,bjid:dataGrid.parms.bjid}">详情</el-button>
                  <el-button link type="primary" @click="openEdit=true; row={id:scope.row.id,xsid:scope.row.xsid,xqid:dataGrid.parms.xqid,bjid:dataGrid.parms.bjid}">修改</el-button>
                  <el-button link type="warning" @click="qingKongClick(scope.row)">清空</el-button>
                </div>
                <el-button v-else link type="primary" @click="openSheZhi=true; row={xsid:scope.row.xsid,xqid:dataGrid.parms.xqid,bjid:dataGrid.parms.bjid}">设置</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <piliangshezhi v-if="openPiLiangSheZhi" v-model:openPiLiangSheZhi="openPiLiangSheZhi" :row="row" @ReturnData="bindTable" />
    <shezhi v-if="openSheZhi" v-model:openSheZhi="openSheZhi" :row="row" @ReturnData="bindTable" />
    <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { homeCloseWindow, loadList, loadSelect, actionDelete } from '@/api/common.js'
import { getxkfs } from '@/utils/meiju'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import pagination from '@/components/pagination.vue'
import piliangshezhi from './piliangshezhi.vue'
import shezhi from './shezhi.vue'
import edit from './edit.vue'
import detail from './detail.vue'
const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const xqData = ref([])
const bjData = ref([])
const xkfsData = ref()
const qingKongClick = (item) => {
  const o = { url: '/api/v2/jiaowu/jiaowuxuanxiukexueshengxuanxiuke', data: { ids: [item.id], menuId: sessionStorage.getItem('menuId') } }
  actionDelete(o).then((res) => {
    if (res.code === 200) {
      successPrompt(res.message)
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/banzhuren',
    data: bjData,
    parms: { xqid: dataGrid.value.parms.xqid },
    order: 'xzbdm',
    sort: 'asc',
    loadSuccess: function (res) {
      dataGrid.value.parms.bjid = res.data.length ? res.data[0].id : ''
      bindTable()
    }
  })
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/jiaowuxuanxiukexueshengxuanxiuke/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}
const row = ref()
const openPiLiangSheZhi = ref(false)
const openSheZhi = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'banzhurendaixuan') {
      openList.value = true
      xkfsData.value = getxkfs()
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              dataGrid.value.parms.xqid = element.id
              initBanJi()
            }
          })
        }
      })
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
